console.log("uga-trad.js");

// on modifie le menu mobile des traductions pour avoir la langue écrite en toutes lettres  pour les rubriques nommées FR, EN etc.

(function () {
    // Dictionnaire ISO 639-1 -> nom natif de la langue
    var LANG_NAMES = {
        fr: 'Français',
        en: 'English',
        it: 'Italiano'
        // es: 'Español',
        // de: 'Deutsch',
        // pt: 'Português',
        // nl: 'Nederlands',
        // zh: '中文',
        // ja: '日本語',
        // ar: 'العربية',
        // ru: 'Русский'
    };

    // Regex : capture "XX - YY" (espaces flexibles autour du tiret)
    var PATTERN = /^([A-Za-z]{2})\s*-\s*([A-Za-z]{2,})$/;

    function fixLabel(rawText) {
        var text = rawText.replace(/\s+/g, ' ').trim();
        var match = PATTERN.exec(text);
        if (!match) {
            return null; // format inattendu, on ne touche à rien
        }

        var code = match[1].toLowerCase();
        var label = match[2].toLowerCase();

        // On ne corrige que si le libellé est en fait le code répété (mal nommé)
        // et qu'on connaît le nom correct pour ce code
        if (label !== code || !LANG_NAMES[code]) {
            return null;
        }

        return match[1].toUpperCase() + ' - ' + LANG_NAMES[code];
    }

    function processElement(el) {
        var fixed = fixLabel(el.textContent);
        if (fixed !== null) {
            el.textContent = fixed;
        }
    }

    function processTopBanner() {
        var container = document.getElementById('topbanner__menu-traductions-ksup');
        if (!container) {
            return;
        }
        var links = container.querySelectorAll('ul[data-menu-panel] li a');
        links.forEach(processElement);
    }

    function processMobileMenu() {
        var container = document.getElementById('menu-mobile-tradksup');
        if (!container) {
            return;
        }
        var labels = container.querySelectorAll('.icon-content__content');
        labels.forEach(processElement);
    }

    function init() {
        processTopBanner();
        processMobileMenu();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
